import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/Home.vue'
import About from '../components/About.vue'
import Contact from '../components/Contact.vue'
import Research from '../components/Research.vue'


import Patrick from '../components/People/Patrick.vue'
import Javier from '../components/People/Javier.vue'
import Paul from '../components/People/Paul.vue'
import David from '../components/People/David.vue'
import Brent from '../components/People/Brent.vue'
import Scott from '../components/People/Scott.vue'
import Cheryl from '../components/People/Cheryl.vue'
import Helen from '../components/People/Helen.vue'
import Greenfield from '../components/People/Greenfield.vue'
import Ranse from '../components/People/Ranse.vue'





Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home

  },


    {
        path: '/annie',
        name: 'annie',
        component: Paul
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
    },
    {
        path: '/patrick',
        name: 'patrick',
        component: Patrick
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
    },
    {
        path: '/savindi',
        name: 'savindi',
        component: Javier
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
    },
    {
        path: '/scott',
        name: 'scott',
        component: David
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
    },

    {
        path: '/stark',
        name: 'stark',
        component: Brent
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
    },

    {
        path: '/cheryl',
        name: 'cheryl',
        component: Cheryl
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
    },

    {
        path: '/helen',
        name: 'helen',
        component: Helen
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
    },

    {
        path: '/gudrun',
        name: 'gudrun',
        component: Scott
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
    },

    {
        path: '/greenfield',
        name: 'greenfield',
        component: Greenfield
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
    },

    {
        path: '/ranse',
        name: 'ranse',
        component: Ranse
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
    },



  {
      path: '/about',
      name: 'About',
      component: About
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
  },

  {
      path: '/contact',
      name: 'Contact',
      component: Contact
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
  },

    {
        path: '/updates',
        name: 'Research',
        component: Research
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
    },


    { path: "*", component: Home }
]

const router = new VueRouter({
  scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
          return savedPosition
      } else {
          return { x: 0, y: 0 }
      }
  },
  base: process.env.BASE_URL,
  routes
})

export default router
